import PropTypes from 'prop-types';

const Holiday = ({ color }) => (
  <svg
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.7526 12.0834C11.5806 10.9115 9.99095 10.2531 8.33347 10.2531C6.67599 10.2531 5.08639 10.9115 3.91431 12.0834M13.1251 1.29486C11.9767 0.631851 10.612 0.452178 9.33109 0.795367C8.05023 1.13856 6.95815 1.9765 6.29508 3.12486L14.9551 8.12486C15.6181 6.97647 15.7978 5.61173 15.4546 4.33087C15.1114 3.05 14.2734 1.95792 13.1251 1.29486ZM13.1251 1.29486C13.9226 1.75486 13.4501 4.06649 12.0684 6.45815M13.1251 1.29486C12.3276 0.834862 10.5626 2.39982 9.18174 4.79149M10.6251 5.625L8.12512 9.955M0.625122 14.1667C0.884532 14.0377 1.16887 13.9666 1.45846 13.9584C1.78304 13.9516 2.10439 14.0239 2.39477 14.1691C2.68515 14.3143 2.93581 14.528 3.12512 14.7917C3.31443 15.0554 3.5651 15.2691 3.85548 15.4143C4.14585 15.5595 4.46721 15.6318 4.79179 15.625C5.11637 15.6318 5.43773 15.5595 5.7281 15.4143C6.01848 15.2691 6.26915 15.0554 6.45846 14.7917C6.64776 14.528 6.89843 14.3143 7.18881 14.1691C7.47919 14.0239 7.80054 13.9516 8.12512 13.9584C8.4497 13.9516 8.77106 14.0239 9.06144 14.1691C9.35181 14.3143 9.60248 14.528 9.79179 14.7917C9.9811 15.0554 10.2318 15.2691 10.5221 15.4143C10.8125 15.5595 11.1339 15.6318 11.4585 15.625C11.783 15.6318 12.1044 15.5595 12.3948 15.4143C12.6851 15.2691 12.9358 15.0554 13.1251 14.7917C13.3144 14.528 13.5651 14.3143 13.8555 14.1691C14.1459 14.0239 14.4672 13.9516 14.7918 13.9584C15.0814 13.9666 15.3657 14.0377 15.6251 14.1667"
      stroke={color}
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

Holiday.propTypes = {
  color: PropTypes.string,
};

Holiday.defaultProps = {
  color: '#696F7C',
};

export default Holiday;
